"use client";

import * as React from "react";

/** is this attribute on <html> right now? Kept current as it comes and goes (the rail, the guide and the
 *  first-run connect step all say what they are doing there, and one surface reads another by it). */
export function useRootFlag(attr: string): boolean {
  const [on, setOn] = React.useState(false);
  React.useEffect(() => {
    const root = document.documentElement;
    const read = () => setOn(root.hasAttribute(attr));
    read();
    const mo = new MutationObserver(read);
    mo.observe(root, { attributes: true, attributeFilter: [attr] });
    return () => mo.disconnect();
  }, [attr]);
  return on;
}
